<div [formGroup]="form" class="row form-wrapper">
  <div class="col-12">
    <app-select-form-field
      formControlName="problemStage"
      [users]="false"
      [label]="'problemRecord.fields.problemStage.label' | translate"
      [items]="stageItems"
      [viewMode]="viewMode"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-status-select-field
      formControlName="nextActionStatus"
      [label]="'problemRecord.fields.nextActionStatus.label' | translate"
      [items]="actionStatusItems"
      [bindValue]="'value'"
      [customClass]="'case-right-section'"
      [itemClass]="form.get('nextActionStatus')?.value"
      (onSelectEvent)="changeNextActionStatus($event)"
    ></app-status-select-field>

  </div>
  <div class="col-12">
    <app-select-form-field
      formControlName="nextActionOwnerId"
      [label]="'problemRecord.fields.nextActionOwnerId.label' | translate"
      [items]="nextActionOwnerUsers"
      [viewMode]="viewMode"
      [bindValue]="'id'"
      [bindLabel]="'fullName'"
      [customClass]="'case-right-section'"
      [isRequired]="nextActionValidators"
      [clearable]="true"
      [searchable]="true"
      [externalSearch]="true"
      (onSearchEvent)="searchUsers('search', $event.term, 'nextActionOwnerUsers', $event.page, $event.take)"
      (onScrollEvent)="searchUsers('scroll', $event.term, 'nextActionOwnerUsers', $event.page, $event.take)"
    ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field
      formControlName="nextActionDueDate"
      [label]="'problemRecord.fields.nextActionDueDate.label' | translate"
      [viewMode]="viewMode"
      [isRequired]="nextActionValidators"
      [minDate]="nextActionValidators ? today : undefined"
      [highlightClass]="getColorOfNextActionDueDate(form.get('nextActionDueDate').value)"
  ></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-textarea-form-field
      formControlName="nextActionDescription"
      [label]="'problemRecord.fields.nextActionDescription.label' | translate"
      [viewMode]="viewMode"
      [isRequired]="nextActionValidators"
    ></app-textarea-form-field>
  </div>
</div>
